import { render } from "./CertAlcoholPendingInspection.vue?vue&type=template&id=0542381c&scoped=true"
import script from "./CertAlcoholPendingInspection.vue?vue&type=script&lang=js"
export * from "./CertAlcoholPendingInspection.vue?vue&type=script&lang=js"

import "./CertAlcoholPendingInspection.vue?vue&type=style&index=0&id=0542381c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0542381c"]])

export default __exports__